/* DoubleDouble: free shipping progress bar ($100 threshold, AUD). Renders into the cart page, cart drawer and add-to-cart panel. */
(function () {
  if (window.ddShipBar) return;
  var THRESHOLD = 10000; // cents

  var css = document.createElement('style');
  css.textContent =
    '.dd-ship{font-size:.8em;text-transform:uppercase;margin:0 0 12px}' +
    '.dd-ship-msg{margin-bottom:6px}' +
    '.dd-ship-track{height:6px;border:1px solid currentColor;border-radius:99px;overflow:hidden}' +
    '.dd-ship-fill{height:100%;background:currentColor;width:0;transition:width .4s ease}' +
    '.cart-page .dd-ship,.gocheckout .dd-ship{margin:12px 0}' +
    '.gocheckout .dd-ship{padding:0 var(--margin,12px)}' +
    '.dd-ship-done .dd-ship-msg{display:inline-block;background:#c6ff00;color:#000;padding:1px 6px}' +
    '.dd-ship-done .dd-ship-track{border-color:#000}' +
    '.dd-ship-done .dd-ship-fill{background:#c6ff00}';
  document.head.appendChild(css);

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function html() {
    return '<div class="dd-ship-msg"></div><div class="dd-ship-track"><div class="dd-ship-fill"></div></div>';
  }

  function paint(node, cart) {
    if (!node) return;
    if (!cart || !cart.item_count || (cart.currency && cart.currency !== 'AUD')) { node.style.display = 'none'; return; }
    node.style.display = '';
    var total = cart.total_price || 0;
    var left = THRESHOLD - total;
    node.classList.toggle('dd-ship-done', left <= 0);
    node.querySelector('.dd-ship-msg').textContent = left > 0
      ? money(left) + ' away from free shipping'
      : '\u2713 You\u2019ve unlocked free shipping';
    node.querySelector('.dd-ship-fill').style.width = Math.min(100, Math.round(total / THRESHOLD * 100)) + '%';
  }

  function ensure(parent, before) {
    if (!parent) return null;
    var node = parent.querySelector(':scope > .dd-ship');
    if (!node) {
      node = document.createElement('div');
      node.className = 'dd-ship';
      node.innerHTML = html();
      if (before && before.parentNode === parent) parent.insertBefore(node, before); else parent.insertBefore(node, parent.firstChild);
    }
    return node;
  }

  var last = null;
  function update(cart) {
    if (cart) last = cart;
    if (!last) return;
    // Cart page: above the checkout button
    var actions = document.querySelector('.cart-page .actions');
    if (actions) {
      var btn = document.getElementById('thecheckoutbutton');
      paint(ensure(actions, btn && btn.parentNode), last);
    }
    // Cart drawer: top of the checkout area
    document.querySelectorAll('.gocheckout').forEach(function (g) { paint(ensure(g, null), last); });
    // Add-to-cart panel
    document.querySelectorAll('#dd-atc .dd-ship-slot').forEach(function (slot) { paint(ensure(slot, null), last); });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { update(cart); return cart; })
      .catch(function () {});
  }

  window.ddShipBar = { update: update, refresh: refresh };

  document.addEventListener('cart.requestComplete', function (e) { if (e.detail && e.detail.items) update(e.detail); else refresh(); });
  function bindJq() {
    if (window.jQuery) jQuery(document).on('cart.requestComplete', function (e, cart) { if (cart && cart.items) update(cart); else refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bindJq(); refresh(); });
  else { bindJq(); refresh(); }
})();
